import { render, staticRenderFns } from "./Deviation.vue?vue&type=template&id=5d281f84&scoped=true&"
import script from "./Deviation.vue?vue&type=script&lang=js&"
export * from "./Deviation.vue?vue&type=script&lang=js&"
import style0 from "./Deviation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Deviation.vue?vue&type=style&index=1&id=5d281f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d281f84",
  null
  
)

export default component.exports